export default __webpack_public_path__ + "static/media/lijSample.6e3ebe73.png";